import { render, staticRenderFns } from "./KeywordMovementTable.vue?vue&type=template&id=a5953d86&scoped=true"
import script from "./KeywordMovementTable.vue?vue&type=script&lang=js"
export * from "./KeywordMovementTable.vue?vue&type=script&lang=js"
import style0 from "./KeywordMovementTable.vue?vue&type=style&index=0&id=a5953d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5953d86",
  null
  
)

export default component.exports